import { Building2, Megaphone, Palette, ShoppingCart } from "lucide-react";
import { Outlet } from "react-router-dom";
import { dashboardPath } from "../../config/storefrontRouting";
import { useTranslation } from "../../i18n";
import { RESOURCE_PERMISSIONS } from "../../permissions/resourcePermissions";
import { useAuth } from "../../permissions/useAuth";
import SubNavigation from "../SubNavigation";

export default function SettingsLayout() {
  const { t, dir } = useTranslation();
  const { hasAnyPermission, isCompanyPrincipal } = useAuth();
  const items = [
    ...(isCompanyPrincipal
      ? [
          {
            to: dashboardPath("/settings/appearance"),
            label: t("settings.nav.appearance"),
            icon: <Palette className="h-4 w-4" aria-hidden />,
          },
        ]
      : []),
    ...(hasAnyPermission([...RESOURCE_PERMISSIONS.BANNERS])
      ? [
          {
            to: dashboardPath("/settings/banners"),
            label: t("settings.nav.banners"),
            icon: <Megaphone className="h-4 w-4" aria-hidden />,
          },
        ]
      : []),
    ...(hasAnyPermission([...RESOURCE_PERMISSIONS.COMMERCE_SETTINGS])
      ? [
          {
            to: dashboardPath("/settings/commerce"),
            label: t("settings.nav.commerce"),
            icon: <ShoppingCart className="h-4 w-4" aria-hidden />,
          },
        ]
      : []),
    ...(isCompanyPrincipal
      ? [
          {
            to: dashboardPath("/settings/company"),
            label: t("settings.nav.company"),
            icon: <Building2 className="h-4 w-4" aria-hidden />,
          },
        ]
      : []),
  ];

  return (
    <section dir={dir} className="mx-auto max-w-7xl space-y-6">
      <header>
        <h1 className="text-2xl font-bold text-foreground">
          {t("settings.title")}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t("settings.subtitle")}
        </p>
      </header>
      <SubNavigation items={items} ariaLabel={t("settings.navigation")} />
      <Outlet />
    </section>
  );
}
